// Implements legacy (<= 3.x) observable map methods
export const observableMap = {
    keys: (map) => Array.from(map.toJS().keys()),

    values: (map) => Array.from(map.toJS().values())
};